
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiBuoySuper as ObiBuoySuperElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-buoy-super.js';
 
 
 

 
 export const ObiBuoySuper = createComponent({
   react: React,
   tagName: 'obi-buoy-super',
   elementClass: ObiBuoySuperElement,
   events: {
     
   }
  });
 
 